/**
 * eSalon — Growth landing FAQ slide (WEB-6534)
 *
 * Slides each answer in sections/esalon-growth-faq.liquid down on open and up
 * on close, like the legacy Bootstrap collapse on www.esalon.com/custom-hair-growth.
 * The panels stay native <details>, so without JS they still open and close,
 * just without the slide.
 *
 * <details> cannot animate its own toggle: `open` shows or hides the content in
 * one frame. So the summary click is intercepted and the answer's height is
 * animated around the `open` flip — flipped first when opening, after the
 * animation when closing. `is-closing` marks the closing window so the icon
 * reads as a plus as soon as the click lands, not when the slide ends.
 *
 * A click mid-slide reverses from the current height rather than jumping.
 * Under prefers-reduced-motion the slide is skipped entirely.
 *
 * Markup contract:
 *   <esalon-growth-faq>
 *     <details> <summary>…</summary> <div data-faq-answer>…</div> </details>
 */
(function () {
  'use strict';

  var DURATION = 300;
  var EASING = 'ease';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class EsalonGrowthFaq extends HTMLElement {
    // connectedCallback runs again whenever the element is re-attached — the
    // theme editor moves a section's DOM when sections are reordered. Binding
    // twice would run toggle() twice per click (open, then straight back shut),
    // so each summary is bound once and marked.
    connectedCallback() {
      this.querySelectorAll('details').forEach((item) => {
        var summary = item.querySelector('summary');
        var answer = item.querySelector('[data-faq-answer]');
        if (!summary || !answer || summary.dataset.faqBound) return;
        summary.dataset.faqBound = 'true';
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(item, answer);
        });
      });
    }

    toggle(item, answer) {
      var closing = item.open && !item.classList.contains('is-closing');

      // Measure before cancelling: a cancelled animation snaps back to the
      // element's natural height, and reversing needs the in-flight one.
      var from = item.open ? answer.getBoundingClientRect().height : 0;
      if (item._slide) {
        item._slide.cancel();
        item._slide = null;
      }

      if (prefersReducedMotion()) {
        item.classList.remove('is-closing');
        item.open = !closing;
        return;
      }

      if (closing) {
        item.classList.add('is-closing');
        item._slide = answer.animate([{ height: from + 'px' }, { height: '0px' }], {
          duration: DURATION,
          easing: EASING,
        });
        item._slide.onfinish = function () {
          item.open = false;
          item.classList.remove('is-closing');
          item._slide = null;
        };
      } else {
        item.classList.remove('is-closing');
        item.open = true;
        var to = answer.scrollHeight;
        item._slide = answer.animate([{ height: from + 'px' }, { height: to + 'px' }], {
          duration: DURATION,
          easing: EASING,
        });
        item._slide.onfinish = function () {
          item._slide = null;
        };
      }
    }
  }

  if (!customElements.get('esalon-growth-faq')) {
    customElements.define('esalon-growth-faq', EsalonGrowthFaq);
  }
})();
